import type { VendingMachineLocation } from '~/contracts/vm';

// inject dynamic API response data into FAQ Question/Answer
export default function injectFaqData(
  vendingMachineLocations: VendingMachineLocation[]
) {
  const vmCount = vendingMachineLocations.length || 40;

  return [
    {
      question: 'Will I still be able to pick up my car at a Vending Machine?',
      answer:
        'Yes! Our Vending Machines have switched to providing Touchless Private Appointments to support social distancing.',
      items: [
        'We book only one appointment per 45 min to ensure there is no overlap between customers and ample time between each appointment to sanitize the lobby, including all door handles, tables, chairs and Carvana coins. Your Carvana Team member will stay 6ft away all times and use a designated table to exchange documents and items',
        'You may have up to 2 household members accompany you. We ask that you arrive on time in support of these efforts and to reschedule your appointment if you are feeling unwell.'
      ]
    },
    {
      question: "How do Carvana's Car Vending Machines work?",
      answer:
        'To pick-up a purchased vehicle at a Carvana Car Vending Machine, the customer simply drops their custom coin (which they receive upon arrival) into the Car Vending Machine’s coin slot, which then illuminates the coin receptacle and activates the automated vehicle delivery system. With the customer looking on, the Car Vending Machine then retrieves the vehicle from the Tower and brings it directly to a delivery bay. Once in the bay, the customer is invited to take possession of their car, where they will have seven days to drive the car around town before ultimately deciding if the vehicle is right for them.'
    },
    {
      question: 'How many Carvana Car Vending Machines are there?',
      answer: `There are currently ${vmCount} Carvana Car Vending Machines scattered throughout the country, with many more planned for future markets. The very first Car Vending Machine was built and launched in Nashville (Tenn.) in 2015, while the tallest Car Vending Machine resides in Tempe (Ariz.) and stands nine stories.`
    },
    {
      question: 'Can I buy a car I see inside the Carvana Vending Machine?',
      answer:
        'The vehicles inside a Carvana Car Vending Machine are usually already sold to customers that will be coming to pick up their vehicles. However, we’d be happy to help you find a similar vehicle on our website that you can pick up at the Car Vending Machine during your appointment!'
    },
    {
      question: 'Can I keep my Car Vending Machine token?',
      answer:
        'Of course! The token customers receive when they arrive for pick up at the Car Vending Machine is a memento that serves to commemorate your experience with us. You are free to take it home with you!'
    }
  ];
}
